var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-outer"}},[_c('div',{attrs:{"id":"navigation-inner"}},[_vm._t("default",null,{isVisible:_vm.isVisible,toggle:_vm.toggle,expandedClass:_vm.expandedClass})],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dff56c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Navigation/Wrapper.vue
// module id = hHmf
// module chunks = 1